module.exports = __webpack_public_path__ + "components/country-flag/static/kp-86a04831f360cc233aa2cbe7c61e54d2.svg";